import React, { useState } from "react";
import algoliasearch from "algoliasearch/lite";
import {
	InfiniteHits,
	InstantSearch,
	SearchBox,
} from "react-instantsearch-hooks-web";
import SuggestedVideo from "../suggested-video/suggested-video.component";
import "./search-bar-with-results.styles.css";
import MiniLessonsThumbnail from "../mini-lessons-thumbnail/mini-lessons-thumbnail.component";

const searchClient = algoliasearch(
	"I7CH9Z5PYN",
	"9cc9f399b9246a75c1b5ae78f9931745"
);

function Hit({ hit }) {
	return (
		<div>
			{hit != null ? (
				hit.Type === "mini_lesson" ? (
					<MiniLessonsThumbnail
						videoURL={hit.VideoThumbnailURL}
						miniLessonID={hit.objectID}
						isHLSType={false}
					/>
				) : (
					<SuggestedVideo
						{...hit}
						Date={{ seconds: hit.Date }}
						DocID={hit.objectID}
					/>
				)
			) : (
				"something went wrong"
			)}
		</div>
	);
}

function SearchBarWithResults({
	onHitsHiding = () => {},
	onHitsShowing = () => {},
}) {
	const [hitsAreVisible, setHitsAreVisible] = useState(false);

	return (
		<InstantSearch searchClient={searchClient} indexName="Videos">
			{/* Widgets */}
			<SearchBox
				placeholder="search"
				onInput={e => {
					if (e.target.value !== "") {
						setHitsAreVisible(true);
						onHitsShowing();
					} else {
						setHitsAreVisible(false);
						onHitsHiding();
					}
				}}
			/>
			{hitsAreVisible ? (
				<InfiniteHits hitComponent={Hit} showPrevious={false} />
			) : null}
		</InstantSearch>
	);
}

export default SearchBarWithResults;
